import React from "react";
import { Link } from "react-router-dom";

const CodeKey = (cell) => {
    return cell.value ? cell.value : '';
};


const titular = (cell) => {
    return cell.value ? cell.value : '';
};

const Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Created_at = (cell) => {
    return cell.value ? cell.value : '';
};

const Active = (cell) => {
    return !cell.value ? <label className="text-white bg-danger text-center p-1" style={{width:'100%'}} >{'Baja'} </label>: <label className="text-center p-1" style={{backgroundColor:'green',color:"white", width:'100%'}}>{'Activo'}</label> ;
};

const GetLink = (cell) => {
    return <Link to={cell.value} target="_blank" className="text-white btn bg-info text-center p-1" style={{width:'100%'}} > {'Descargar'} </Link>;
};

const Options = ({cell, onEdit, onDelete}) => {
    return <div className="btn-group">
        <button className="btn btn-warning" onClick={() => onEdit(cell.row.original)}>Editar</button>
        <button className="btn btn-danger" onClick={() => onDelete(cell.row.original)}>Eliminar</button>
    </div>;
};


export {
    Name,
    Created_at,
    Active,
    Options,
    GetLink
};
